import {
  ChangeDetectionStrategy,
  Component,
  NgModule,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'i2l-empty',
  template: ``,
  styles: [],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyComponent {}

@NgModule({
  imports: [CommonModule],
  declarations: [EmptyComponent],
  exports: [EmptyComponent],
})
export class EmptyComponentModule {}
